<template>
    <div>
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="pricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="bg-white rounded p-2 mb-2">
            <div v-for="(pricePoint, index) in automations.price_points" :key="index">
                <div v-if="pricePointsTab ===
                    'data_sharing_product_price_point_' + pricePoint.id
                    " class="flex flex-col w-full">
                    <div class="flex flex-col w-full bg-white mb-2"></div>
                </div>
            </div>
        </div>
    </affiliate-workspace>
    </div>
</template>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
export default {
    components: { AffiliateWorkspace },
    props: {
        pricePointsTabs: {
            type: Array,
            required: true,
        },
        pricePointsTab: {
            type: String,
            required: true,
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true,
        },
        automations: {
            type: Object,
            required: true,
        },
    },

    computed: {
        pricePointsErrorTabs() {
            return [];
        },
    }
}

</script>